module.exports = __webpack_public_path__ + "img/people-32-min.b063bb26.png";